import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GoArrowRight } from "react-icons/go";

import bag from "../../../../assets/Icons/dashboard/👜.png";
import MaButton from "../../../../Components/UI/ma-button";
import { GET_SELLER_ORDERS_WITH_CUSTOMER } from "../../../../Utils/Queries";

function formatOrderPrice(amountPaid, currency) {
  const n = Number(amountPaid);
  if (Number.isNaN(n)) return "—";
  const sym = currency?.symbol || "$";
  return `${sym}${n.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

const RecentOrdersCard = () => {
  const { data, loading, error } = useQuery(GET_SELLER_ORDERS_WITH_CUSTOMER);
  const rows = useMemo(() => {
    const raw = data?.getSellerOrdersWithCustomer?.items;
    const items = Array.isArray(raw) ? raw : [];
    return items.slice(0, 5).map((item) => ({
      id: item._id,
      product: item.product?.name || "—",
      sku: item.product?.reference || item.reference || "—",
      image: item.product?.images?.[0],
      customer: [item.buyer?.firstName, item.buyer?.lastName]
        .filter(Boolean)
        .join(" ")
        .trim() || "—",
      city: "—",
      quantity: item.quantity ?? "—",
      price: formatOrderPrice(item.amountPaid, item.order?.currency),
    }));
  }, [data]);

  const showEmpty = !loading && !error && rows.length === 0;

  return (
  <div className="bg-white rounded-[14px] border border-[#EFEFEF] p-5 h-[450px] flex flex-col">
    <div className="flex items-center justify-between mb-3 shrink-0">
      <h3 className="text-[15px] font-semibold text-[#3D3D3D] my-0">
        Recent Orders
      </h3>
      <MaButton
      variant={"link"}
       title=" View All"
       sx={{textDecoration:'initial', fontSize:'12px', fontWeight:700}}
       endIcon={ <GoArrowRight className="text-[14px]" />}
      />
       
   
    </div>

    <div className="flex-1 min-h-0 flex flex-col overflow-x-auto">
      {error && !loading ? (
        <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
          <p className="text-[14px] font-semibold text-[#3D3D3D] my-0">
            Couldn&apos;t load orders
          </p>
          <p className="text-[12.5px] text-[#6B7280] mt-2 my-0 max-w-[280px] leading-snug">
            Something went wrong while fetching your orders. Try refreshing
            the page.
          </p>
        </div>
      ) : loading ? (
        <div className="flex-1 flex items-center justify-center px-4">
          <p className="text-[13px] text-[#9CA3AF] my-0">Loading recent orders…</p>
        </div>
      ) : showEmpty ? (
        <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
          <p className="text-[14px] font-semibold text-[#3D3D3D] my-0">
            No orders yet
          </p>
          <p className="text-[12.5px] text-[#6B7280] mt-2 my-0 max-w-[280px] leading-snug">
            When customers place orders, they will show up in this list.
          </p>
        </div>
      ) : (
      <table className="w-full text-left">
        <thead>
          <tr className="bg-[#F8F8F8]">
            <th className="text-[11px] font-[600] text-[#999999] tracking-wider uppercase px-4 py-3">
              Product
            </th>
            <th className="text-[11px] font-[600] text-[#999999] tracking-wider uppercase px-4 py-3">
              Customer
            </th>
            <th className="text-[11px] font-[600] text-[#999999] tracking-wider uppercase px-4 py-3">
              Quantity
            </th>
            <th className="text-[11px] font-[600] text-[#999999] tracking-wider uppercase px-4 py-3">
              Price
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} className="border-b border-[#EAEAEA] last:border-b-0 border-b-solid">
              <td className="px-4 py-3">
                <div className="flex items-center gap-3">
                  <ProductThumb src={row.image} alt="" />
                  <div>
                    <p className="text-[13px] font-[600] my-0 text-[#626262] leading-tight">
                      {row.product}
                    </p>
                    <p className="text-[11.5px] text-[#9CA3AF] mt-0.5">
                      {row.sku}
                    </p>
                  </div>
                </div>
              </td>
              <td className="px-4 py-3">
                <p className="text-[13px] font-[600] my-0 text-[#626262] leading-tight">
                  {row.customer}
                </p>
                <p className="text-[11.5px] text-[#9CA3AF] mt-0.5">
                  {row.city}
                </p>
              </td>
              <td className="px-4 py-3 text-[13px] text-[#151515]">
                {row.quantity}
              </td>
              <td className="px-4 py-3 text-[13px] text-[#151515]">
                {row.price}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  </div>
  );
};

export default RecentOrdersCard;

export const ProductThumb = ({ src, alt = "" }) => (
  <div className="w-9 h-9 rounded-md flex items-center justify-center shrink-0 overflow-hidden bg-[#F8F8F8]">
    <img src={src || bag} alt={alt} className="w-full h-full object-cover" />
  </div>
);